module.exports = __webpack_public_path__ + "static/media/OurStoryArrow.e99c58ef.svg";